import api from '@/api/services/api'

const getCollection = params => api({
  method: 'get',
  url: 'orders',
  params
})

const getOrder = ({ id, params }) => api({
  method: 'get',
  url: `/orders/${id}`,
  params
})

const getMessages = params => api({
  method: 'get',
  url: '/orders/message',
  params
})

const sendMessage = data => api({
  method: 'post',
  url: '/orders/message',
  data
})

const getPenalties = params => api({
  method: 'get',
  url: '/orders/penalties',
  params
})

const sendFeedback = (id, data) => api({
  method: 'post',
  url: `/orders/${id}/feedback`,
  data
})

const updateFeedback = (id, data) => api({
  method: 'put',
  url: `/orders/${id}/feedback`,
  data
})

const downloadDocument = bookingId => api({
  method: 'get',
  url: `/bookings/${bookingId}/voucher`
})

const downloadAllDocuments = orderId => api({
  method: 'get',
  url: `/orders/${orderId}/voucher`
})

const sendDocument = (bookingId, params) => api({
  method: 'get',
  url: `/bookings/${bookingId}/voucher/send`,
  params
})

export {
  getCollection,
  getOrder,
  getPenalties,
  sendFeedback,
  updateFeedback,
  getMessages,
  sendMessage,
  downloadDocument,
  downloadAllDocuments,
  sendDocument
}